import { noop } from '@rhim/utils';

import type { AnalyticsInterface } from '../services/AnalyticsInterface';

/**
 * Create a no-op analytics instance for scenarios where analytics should be disabled
 * (e.g., testing environments, edge mode).
 * Returns a Proxy that makes all method calls no-ops.
 */
export function createNoOpAnalytics<E = string, P = Record<string, unknown>>(): AnalyticsInterface<E, P> {
  return new Proxy({} as AnalyticsInterface<E, P>, {
    get: (target, prop: keyof AnalyticsInterface<E, P>) => {
      if (!(prop in target)) {
        target[prop] = noop;
      }
      return target[prop];
    },
  });
}
